import React, { useEffect, useState } from "react";

import ConventionSchedule from "../convention-schedule/ConventionSchedule";
import ConventionMap from "../convention-map/ConventionMap";
import { Tabs } from "@material-ui/core";
import { Tab } from "@material-ui/core";

const Convention = (props) => {
  const [conventionData, setConventionData] = useState({});
  const [scheduleEvents, setScheduleEvents] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  //add a redirect from classroom to classrooms if nothing was selected
  useEffect(() => {}, []);
  return (
    <div>
      <Tabs value={selectedTab} onChange={handleChange} aria-label="">
        <Tab label="Schedule" value={0} />
        <Tab label="Map" value={1} />
      </Tabs>
      {selectedTab === 0 && (
        <ConventionSchedule
          ScheduleEvents={scheduleEvents}
        ></ConventionSchedule>
      )}
      {selectedTab === 1 && <ConventionMap></ConventionMap>}
    </div>
  );
};
export default Convention;
